import React from "react";
import s from "./style.module.scss";
import { INavItem } from "./Item/types";
import { ROUTES_PATH } from "shared/constants/routesPath";
import Item from "./Item";
import { useAppSelector } from "shared/redux/hooks";
import { userSelect } from "shared/redux/selectors/user";

const Navigation: React.FC = () => {
  const { user_info } = useAppSelector(userSelect);

  const navList: INavItem[] = [
    {
      href: ROUTES_PATH.ABOUT,
      label: "О программе",
    },

    {
      href: ROUTES_PATH.MY_GIFTS,
      label: "Мои подарки",
      updates: user_info?.bonus_new,
    },

    {
      href: ROUTES_PATH.HISTORY,
      label: "История начислений",
    },

    {
      href: ROUTES_PATH.INVITE,
      label: "Пригласи друга",
      bonuses: 100,
    },

    {
      href: ROUTES_PATH.SUPPORT,
      label: "Обратная связь",
    },
  ];

  return (
    <ul className={s.nav}>
      {navList.map((item) => (
        <Item {...item} key={item.href} />
      ))}
    </ul>
  );
};

export default Navigation;
